document.addEventListener("DOMContentLoaded", function () {
    const toggleBtn = document.querySelector(".ingredient-toggle");
    const extraBox = document.querySelector(".ingredient-extra");
    const hiddenItems = document.querySelectorAll(".ingredient-item.is-hidden");
    const textEl = document.querySelector(".btn-text");
    const arrow = document.querySelector(".ingredient-arrow");
  
    if (!toggleBtn) return;
  
    let isOpen = false;
  
    toggleBtn.addEventListener("click", function () {
      isOpen = !isOpen;

      hiddenItems.forEach(item => {
        item.style.display = isOpen ? "flex" : "none";
      });
  
      if (extraBox) {
        if (isOpen) {
          extraBox.classList.add("open");
          extraBox.style.maxHeight = extraBox.scrollHeight + "px";
        } else {
          extraBox.style.maxHeight = "0px";
          setTimeout(() => extraBox.classList.remove("open"), 300);
        }
      }
  
      if (textEl) {
        textEl.innerText = isOpen ? "Show Less" : "All Ingredients";
      }
  
      if (arrow) {
        arrow.classList.toggle("rotate", isOpen);
      }
    });
  });

  document.querySelectorAll('.accordion-trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      var targetId = this.getAttribute('aria-controls');
      var content = document.getElementById(targetId);
      this.setAttribute('aria-expanded', String(!expanded));
      content.classList.toggle('is-open', !expanded);
    });
  });



  function updateFlagImages() {
  document.querySelectorAll('img.ts-img').forEach((img) => {
    if (img.src.includes('/flags/us.svg')) {
      img.src = 'https://app.transtore.app/flags/gb.svg';
    }
  });
}

// Initial run
updateFlagImages();

// Watch for DOM changes
const observer = new MutationObserver(() => {
  updateFlagImages();
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});